import {
    ARTICLES_DELETE_ARTICLE,
    ARTICLES_FETCH_ARTICLE,
    ARTICLES_LOAD_LIST,
    ARTICLES_PUSH_TO_LIST,
    ARTICLES_REPLACE_ARTICLE,
    ARTICLES_SET_ACTIVE_ID,
    ARTICLES_SET_ERROR_MESSAGE,
    ARTICLES_SET_LIST,
    ARTICLES_SET_NOW_LOADING
} from '@src/_redux/articles/constants';
import {IArticleModel} from '@src/@interfaces/models/Article/IArticleModel';

type ID = NonNullable<IArticleModel['id']>;

export const articlesLoadList = () => ({
    type: ARTICLES_LOAD_LIST,
});

export const articlesSetNowLoading = (state: boolean) => ({
    type: ARTICLES_SET_NOW_LOADING,
    payload: {isLoading: state},
});

export const articlesSetList = (articles: IArticleModel[]) => ({
    type: ARTICLES_SET_LIST,
    payload: {articles},
});

export const articlesPushToList = (article: IArticleModel) => ({
    type: ARTICLES_PUSH_TO_LIST,
    payload: {article},
});

export const articlesSetActiveId = (articleId: 'create' | ID | null) => ({
    type: ARTICLES_SET_ACTIVE_ID,
    payload: {articleId},
});

export const articlesFetchArticle = (articleId: 'create' | ID | null) => ({
    type: ARTICLES_FETCH_ARTICLE,
    payload: {articleId},
});

export const articlesReplaceArticle = (article: IArticleModel) => ({
    type: ARTICLES_REPLACE_ARTICLE,
    payload: {article},
});

export const articlesDeleteArticle = (articleId: ID | null) => ({
    type: ARTICLES_DELETE_ARTICLE,
    payload: {articleId},
});

export const articlesSetErrorMessage = (errorMessage: string | null) => ({
    type: ARTICLES_SET_ERROR_MESSAGE,
    payload: {errorMessage},
});
